module.exports = __webpack_public_path__ + "static/media/Questions-29-40.1aef1a3e.png";